import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ICrearGuiaRemisionReq } from '@core/interfaces/request-response/guia-remision.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({ providedIn: 'root' })
export class GuiaRemisionApiService extends BaseHttpService {
  crear(req: ICrearGuiaRemisionReq) {
    return this.withLoader(
      this.httpClient.post(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/crear`, req),
    );
  }

  crearDesdeVenta(ventaId: number) {
    return this.withLoader(
      this.httpClient.post(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/desde-venta/${ventaId}`, {}),
    );
  }

  emitir(id: number) {
    return this.httpClient.post(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/${id}/emitir`, {});
  }

  consultarEstado(id: number) {
    return this.httpClient.get(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/${id}/estado`);
  }

  anular(id: number, motivo: string) {
    return this.httpClient.post(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/${id}/anular`, { motivo });
  }

  listar(pagina: number = 1, size: number = 50) {
    const params = new HttpParams().set('pagina', pagina).set('size', size);
    return this.httpClient.get(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/listar`, { params });
  }

  detalle(id: number) {
    return this.httpClient.get(`${environment.apiFacturacionUrl}${environment.apiPreFix}/guia-remision/detalle/${id}`);
  }
}
